"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EmptySwatch: function() {
        return _index.EmptySwatch;
    },
    emptySwatchClassNames: function() {
        return _index.emptySwatchClassNames;
    },
    renderEmptySwatch_unstable: function() {
        return _index.renderEmptySwatch_unstable;
    },
    useEmptySwatchStyles_unstable: function() {
        return _index.useEmptySwatchStyles_unstable;
    },
    useEmptySwatch_unstable: function() {
        return _index.useEmptySwatch_unstable;
    }
});
const _index = require("./components/EmptySwatch/index");
